
const API_BASE_URL = "https://zxjcav222g.execute-api.eu-central-1.amazonaws.com/dev";

/**
 * Call API to send contact form
 * @param {Object} contactFormData - Contact form data containing first_name, last_name, email, phone, company, subject, and message
 * @returns {Promise<Object>} - API response
 */
export const sendContactForm = async (contactFormData) => {
    try {
      console.log('Sending contact form:', contactFormData);
      const url = `${API_BASE_URL}/send-contact-mail`;
      
      const response = await fetch(url, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json" 
        },
        body: JSON.stringify(contactFormData)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Failed to send contact form: ${response.status} ${response.statusText}`);
      }
      
      const responseData = await response.json();
      console.log("Send contact form API response:", responseData);
      
      return responseData;
    } catch (error) {
      console.error("Error sending contact form:", error);
      throw error;
    }
  };